import EmailTemplateApi from '@/services/api/emailTemplateApi'

const EmailTemplateStore = {
  namespaced: true,
  state: {
    emailTemplate: {},
    suggestedName: null, // pass a suggested name to the save
    mergeTags: [],
    specialLinks: []
  },
  mutations: {
    saveEmailTemplate: (state, payload) => {
      // handle cases were coming from API (.data) and from setting directly from list
      if (!payload) {
        state.emailTemplate = {}
      } else if (payload.data) {
        state.emailTemplate = payload.data
      } else {
        state.emailTemplate = payload || {}
      }
    },
    resetEmailTemplate: state => {
      state.emailTemplate = {}
    },
    setSuggestedName: (state, name) => {
      state.suggestedName = name
    },
    resetSuggestedName: state => {
      state.suggestedName = null
    },
    saveMergeTags: (state, payload) => {
      state.mergeTags = payload
    },
    saveSpecialLinks: (state, payload) => {
      state.specialLinks = payload
    }
  },
  actions: {
    getEmailTemplate ({ state, commit }, payload) {
      return EmailTemplateApi.getEmailTemplate(payload.id)
        .then(emailTemplate => {
          commit('saveEmailTemplate', emailTemplate.data)
          Promise.resolve(state.emailTemplate)
        })
        .catch(error => {
          Promise.reject(error)
        })
    },
    getMergeTags ({ state, commit }) {
      return EmailTemplateApi.getMergeTags()
        .then(resp => {
          commit('saveMergeTags', resp.data)
          Promise.resolve(state.mergeTags)
        })
        .catch(error => {
          Promise.reject(error)
        })
    },
    getSpecialLinks ({ state, commit }) {
      return EmailTemplateApi.getSpecialLinks()
        .then(resp => {
          commit('saveSpecialLinks', resp.data)
          Promise.resolve(state.specialLinks)
        })
        .catch(error => {
          Promise.reject(error)
        })
    }
  },
  getters: {
  }

}

export default EmailTemplateStore
